navigator.serviceWorker.register("/service-worker.js", {
  scope: '/'
})